import React from 'react';
import styles from './Bio.module.scss';

// images
import dart from './../../../Assets/images/icons/dart.svg';
 
const Bio = ({bioModalState, setBioModalState}) => {
  return (
    <div className={styles.modal} onClick={() => setBioModalState(false)}>
      <div className={styles.content} onClick={e => e.stopPropagation()}>
        <div className={styles.top}>
          <div className={styles.title}>Генеральный директор – Савченко Андрей Владимирович</div>
          <button className={styles.closeButton} type="button" onClick={() => setBioModalState(false)} aria-label="Закрыть окно">
            <img src={dart} alt="" />
          </button>
        </div>
        <div className={styles.text}>
          <b>Образование</b>
          <ul>
            <li>В 2002 году окончил Санкт-Петербургский государственный горный институт им.Г.В.Плеханова (технический университет).</li>
            <li>Присвоена квалификация «Инженер» по специальности «Инженерная защита окружающей среды»</li>
          </ul>
          
          <b>Опыт работы</b>
          <ul>
            <li>2002 г.: Филиал НПЦ ОЭКН «Комета», Инженер по охране окружающей среды</li>
            <li>С 2003 г. по 2008 г.: ЗАО «Механобр инжиниринг», Руководитель группы отдела охраны окружающей среды</li>
            <li>С 2008 г. по 2013 г.: ООО «ИКТП», Заместитель начальника отдела экологического обоснования проектной деятельности</li>
            <li>С 2013 г. по 2018 г.: ЗАО «Институт «Трансэкопроект», Заместитель директора по инженерной экологии – начальник управления проектных работ</li>
            <li>С 2018 г. по 2020 г.: ООО «ПИ Петрохим-технология», Главный инженер проекта</li>
            <li>С 2021 г. по настоящее время: АО «ЭСП», Генеральный директор</li>
          </ul>
          
          <b>Награды</b>
          <ul>
            <li>2014 г.: Награжден почетной грамотой НП дорожных проектных организаций «РОДОС»</li>
            <li>2016 г.: Объявлена благодарность Комитета по развитию транспортной инфраструктуры Санкт-Петербурга</li>
            <li>2018 г.: Благодарственное письмо Департамента транспорта и дорожно-благоустроительного комплекса мэрии города Новосибирска «За высокий профессионализм и значительный вклад в развитие дорожно-строительного комплекса города Новосибирска».</li>
            <li>2025 г.: Объявлена благодарность Комитета по природопользованию, охране окружающей среды и обеспечению экологической безопасности.</li>
          </ul>

          <b>Семейное положение</b>
          <div>Женат, воспитывает двоих детей</div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(Bio);
